<template>
    <b-navbar :class="{'px-0': short}">
        <b-nav
            pills
            vertical
            class="pt-3 w-100"
        >
            <b-nav-item
                v-for="(route, code) in $store.state.menu.list"
                :key="code"
                :active="$route.matched[0] === route.matched[0]"
                :class="settingsClasses(route.name)"
                activeClass="bg-light"
                @click="openPage($event, route.path)"
            >
                <b-row>
                    <b-col
                        :cols="short ? 12 : 1"
                    >
                        <i
                            v-if="route.meta.icon"
                            :id="route.name"
                            :class="`icon-${route.meta.icon}`"
                            class="icon m-auto"
                        />
                    </b-col>
                    <b-col v-if="!short">
                        <span>{{ $t(`main.menu.${route.meta.menuTitle}`) }}</span>
                        <font-awesome-icon
                            v-if="isSetting(route.name)"
                            class="chevron"
                            :class="iconClasses"
                            size="xs"
                            icon="chevron-down"
                        />
                    </b-col>
                    <b-tooltip
                        v-else
                        :target="route.name"
                        placement="right"
                        triggers="hover"
                    >
                        {{ $t(`main.menu.${route.meta.menuTitle}`) }}
                    </b-tooltip>
                </b-row>
                <settings-menu v-if="isOpenSettings && isSetting(route.name)" />
            </b-nav-item>
            <b-nav-item>
                <event-status-group
                    v-if="checkAccess('viewEventStatusGroup')"
                    :short="short"
                    class="mt-3 border-top border-bottom py-1"
                />
            </b-nav-item>
            <b-link
                class="w-100 toggle-info pl-3"
                @click="toggle"
            >
                <font-awesome-icon :icon="arrow" />
                <span
                    v-if="!short"
                    class="ml-1"
                >
                    {{ $t('main.menu.collapse') }}
                </span>
            </b-link>
        </b-nav>
    </b-navbar>
</template>

<script>
import EventStatusGroup from '@/components/events/StatusGroup';
import SettingsMenu from '@/components/settings/SettingsMenu';
import access from '@/mixins/access';

export default {
    name: 'SidebarMenu',
    components: {
        EventStatusGroup,
        SettingsMenu,
    },

    props: {
        isShort: {
            type: Boolean,
            required: true,
        },
    },

    mixins: [access],

    data() {
        return {
            shortKey: localStorage.getItem('menu') || 'simple',
            isOpenSettings: false,
        };
    },

    computed: {
        'short': vm => vm.shortKey === 'short',
        arrow: vm => 'angle-double-' + (vm.short ? 'right' : 'left'),
        iconClasses() {
            return { 'icon-transform': this.isOpenSettings };
        },
    },

    methods: {
        toggle: function() {
            this.shortKey = this.shortKey === 'simple' ? 'short' : 'simple';
            this.$emit('update:isShort', this.short);
            localStorage.setItem('menu', this.shortKey);
        },

        isSetting(path) {
            return path === 'Setting';
        },

        settingsClasses(name) {
            return { settings: name === 'Setting' };
        },

        openPage(event, route) {
            if (event.target.closest('.settings') && !this.isShort) {
                if (!this.isOpenSettings && this.$route.path !== '/settings') {
                    this.$router.push(route);
                }

                this.isOpenSettings = !this.isOpenSettings;
            } else {
                this.$router.push(route);
                this.isOpenSettings = false;
            }
        },
    },

    watch: {
        isShort(value) {
            if (value) {
                this.isOpenSettings = false;
            }
        },
    },

    mounted() {
        this.$emit('update:isShort', this.short);
    },
};
</script>

<style lang="scss" scoped>
    .nav-link {
        padding: 0;
        line-height: 2em;
    }

    .nav-link > .row {
        padding: 0.75em;
    }

    .chevron {
        margin-left: 0.92em;
        margin-bottom: 0.08em;
    }

    .icon-transform {
        transform: rotate(180deg);
    }
</style>